import api from '../lib/api';

const circlesService = {
  getCircles: () => api.get('/circles'),
  getCircle: (slug) => api.get(`/circles/${slug}`),
};

export default circlesService;
